<template>
  <v-container>
    <GoBackAtTop
      :to="{ name: 'CompanyEmployeesPermissions', params: { id: $route.params.id } }"
      :label="$t('labels.roles')"
    />
    <h1>{{ employee.employed | displayName }}</h1>

    <div class="mb-5 d-flex">
      <div>
        <v-icon class="icon-24 mr-3">{{
          getRoleAvatar(employee, hasDepartments($route.params.id))
        }}</v-icon>
      </div>
      <div v-if="getRoleDescription(employee, hasDepartments($route.params.id)) != ''">
        {{
          getRoleDescription(employee, hasDepartments($route.params.id)) +
          " (" +
          getShortRoleDescription(employee, hasDepartments($route.params.id)) +
          ")"
        }}
        <template v-if="hasDepartments($route.params.id)">
          i <i>{{ getDepartments(employee, getEmpSingleRole(employee, hasDepartments($route.params.id))) }}</i>
        </template>
      </div>
    </div>
<!--YUA can only see instructors with no other roles -->
    <template v-if="(isAdministrator || isDepartmentAdministrator($route.params.id) || (isCompanyEducationResponsible($route.params.id) && ((getEmpSingleRole(employee, true)=='isDepartmentInstructor') || (getEmpSingleRole(employee, false)=='isInstructor') || (getEmpSingleRole(employee, hasDepartments($route.params.id))==null))))">

      <ActionButton
        type="application"
        class="mt-6 mb-6"
        @click="
          $nextTick(() => {
            $router.push({
              name: 'CompanyEmployee',
              params: {
                id: $route.params.id,
                employee_id: $route.params.employee_id,
                show_back_roller: true,
              },
            });
          })
        "
        actionIcon="$sl-user"
        >{{ $t("labels.show-profile") }}</ActionButton
      >
      <v-form ref="form" lazy-validation v-model="valid">
        <MessageBox type="info">
          <h6>{{ $t("roles.title") }}</h6>
          <p>{{ $t("roles.text1") }}</p>
          <p>
            {{ $t("roles.text2") }}
            <a
              target="_blank"
              href="https://www.byggbranschensyrkesnamnd.se/manual/roller/"
              >{{ $t("roles.text3") }}</a
            >
          </p>
        </MessageBox>

        <v-row class="justify-space-between pt-6" no-gutters v-if="(isAdministrator || isDepartmentAdministrator($route.params.id))">
          <v-col cols="10">
            <h5>{{ $t("roles.admin") }}</h5>
          </v-col>
          <v-col cols="2">
            <v-switch
              class="white-switch"
              :disabled="!editAdmin"
              dense
              hide-details
              v-model="isAdministrator_switch"
            ></v-switch>
          </v-col>
          <v-col cols="12" class="mt-n2">
            <p>{{ $t("roles.admin-text") }}</p>
          </v-col>
        </v-row>

        <template v-if="hasDepartments($route.params.id) && (isAdministrator || isDepartmentAdministrator($route.params.id))">
          <v-row
            class="justify-space-between pt-4"
            no-gutters          
          >
            <v-col cols="10">
              <h5>{{ $t("roles.dep-admin") }}</h5>
            </v-col>
            <v-col cols="2">
              <v-switch
                class="white-switch"
                dense
                :disabled="departmentAdministrator_deps.length>0"
                hide-details
                v-model="isDepartmentAdministrator_switch"
              ></v-switch>
            </v-col>
            <v-col cols="12" class="mt-n2">
              <p>{{ $t("roles.dep-text") }}</p>
            </v-col>
          </v-row>
          <v-select
            v-if="
              hasDepartments($route.params.id) == true &&
              isDepartmentAdministrator_switch == true
            "
            v-model="departmentAdministrator_deps"
            :items="departments"
            :rules="[rules.hasDepartments]"
            item-value="value"
            item-text="text"
            :label="$t('company.sections')"
            chips
            outlined
            append-icon="$sl-arrow-down"
            multiple
          >
            <template v-slot:selection="{ attrs, item, selected }">
              <v-chip
                close-icon="$sl-close"
                v-bind="attrs"
                :disabled="item.disabled"
                :input-value="selected"
                close
                @click:close="removeAdmin(item)"
                >{{ item.text }}</v-chip
              >
            </template>
          </v-select>
        </template>
        <template v-if="(isAdministrator || isDepartmentAdministrator($route.params.id))">
          <v-row class="justify-space-between mt-3" no-gutters >
            <v-col cols="10">
              <h5>{{ $t("roles.gb") }}</h5>
            </v-col>
            <v-col cols="2">
              <v-switch
                v-if="hasDepartments($route.params.id) == true"
                :disabled="distanceEducationAdministrator_deps.length>0"
                class="white-switch"
                dense
                hide-details
                v-model="isDistanceEducationAdministrator_switch"
              ></v-switch>
              <v-switch
                v-else
                class="white-switch"
                :disabled="!editAdmin"
                dense
                hide-details
                v-model="isDistanceEducationAdministrator_switch"
              ></v-switch>
            </v-col>
            <v-col cols="12" class="mt-n2">
              <p>{{ $t("roles.gb-text") }}</p>
            </v-col>
          </v-row>
          <v-select
            v-if="
              hasDepartments($route.params.id) == true &&
              isDistanceEducationAdministrator_switch == true
            "
            v-model="distanceEducationAdministrator_deps"
            :items="departments"
            item-value="value"
            item-text="text"
            :label="$t('company.sections')"
            chips
            :rules="[rules.hasDepartments]"
            outlined
            append-icon="$sl-arrow-down"
            multiple
          >
            <template v-slot:selection="{ attrs, item, selected }">
              <v-chip
                close-icon="$sl-close"
                v-bind="attrs"
                :input-value="selected"
                :disabled="item.disabled"
                close
                @click:close="removeDistance(item)"
                >{{ item.text }}</v-chip
              >
            </template>
          </v-select>
        </template>
        <template v-if="(isAdministrator || isDepartmentAdministrator($route.params.id))">
          <v-row class="justify-space-between mt-3" no-gutters>
            <v-col cols="10">
              <h5>{{ $t("roles.yua") }}</h5>
            </v-col>
            <v-col cols="2">
              <v-switch
                v-if="hasDepartments($route.params.id)"
                class="white-switch"
                :disabled="companyEducationResponsible_deps.length>0"
                dense
                hide-details
                v-model="isCompanyEducationResponsible_switch"
              ></v-switch>
              <v-switch
                v-else
                class="white-switch"
                :disabled="!editAdmin"
                dense
                hide-details
                v-model="isCompanyEducationResponsible_switch"
              ></v-switch>
            </v-col>
            <v-col cols="12" class="mt-n2">
              <p>{{ $t("roles.yua-text") }}</p>
            </v-col>
          </v-row>

          <v-select
            v-if="
              hasDepartments($route.params.id) == true &&
              isCompanyEducationResponsible_switch == true
            "
            v-model="companyEducationResponsible_deps"
            :items="departments"
            item-value="value"
            item-text="text"
            :label="$t('company.sections')"
            chips
            :rules="[rules.hasDepartments]"
            outlined
            append-icon="$sl-arrow-down"
            multiple
            class=""
          >
            <template v-slot:selection="{ attrs, item, selected }">
              <v-chip
                close-icon="$sl-close"
                v-bind="attrs"
                :input-value="selected"
                :disabled="item.disabled"
                close
                @click:close="removeYUA(item)"
                >{{ item.text }}</v-chip
              >
            </template>
          </v-select>
        </template>
        <template v-if="isAdministrator || isDepartmentAdministrator($route.params.id) || (isCompanyEducationResponsible($route.params.id) && ((getEmpSingleRole(employee, true)=='isDepartmentInstructor') || (getEmpSingleRole(employee, false)=='isInstructor') || getEmpSingleRole(employee, hasDepartments($route.params.id))==null))">

          <v-row class="justify-space-between mt-3" no-gutters>
            <v-col cols="10">
              <h5>{{ $t("roles.hl")  }}</h5>
            </v-col>
            <v-col cols="2">
              <v-switch
                v-if="hasDepartments($route.params.id)"
                class="white-switch"
                dense
                hide-details
                v-model="isInstructor_switch"
                :disabled="instructor_deps.length>0"
                
              ></v-switch>
              <v-switch
                v-else
                class="white-switch"                
                dense
                hide-details
                v-model="isInstructor_switch"
              ></v-switch>
            </v-col>
            <v-col cols="12" class="mt-n2">
              <p>{{ $t("roles.hl-text") }}</p>
            </v-col>
          </v-row>

          <v-select
            v-if="hasDepartments($route.params.id) == true && isInstructor_switch == true"
            v-model="instructor_deps"
            :items="departments"
            item-value="value"
            item-text="text"
            :label="$t('company.sections')"
            :rules="[rules.hasDepartments]"
            chips
            outlined
            append-icon="$sl-arrow-down"
            multiple
            class=""
          >
            <template v-slot:selection="{ attrs, item, selected }">
              <v-chip
                close-icon="$sl-close"
                v-bind="attrs"
                :disabled="item.disabled"
                :input-value="selected"
                close
                @click:close="removeInstructor(item)"
                >{{ item.text }}</v-chip
              >
            </template>
          </v-select>
        </template>
        <!-- Used to save employee permission -->
        <ActionButton class="mt-6" 
          @click="saveEmployee" 
          actionIcon="$sl-save"
          :isDisabled="isImitatingUser()"
        >
          {{$t("labels.save")}}
        </ActionButton>
      </v-form>
    </template>
    <template v-else>
      <p class="pt-4">{{ $t("roles.missing-permission") }}</p>
    </template>
  </v-container>
</template>

<script>
import API from "@/services/api.js";
import { mapActions, mapGetters } from "vuex";
import GoBackAtTop from "@/components/Common/GoBackAtTop";
import { RulesMixin, CompanyRoles } from "@/components/mixins";
import ActionButton from "@/components/Common/ActionButton";
import find from "lodash/find";
import indexOf from "lodash/indexOf";
import MessageBox from "@/components/Common/MessageBox";
// @group Company
// CompanyEmployeePermissions component
export default {
  name: "CompanyEmployeePermissions",

  mixins: [RulesMixin, CompanyRoles],

  components: {
    GoBackAtTop,
    ActionButton,
    MessageBox,
  },

  data: () => ({
    employee: {},
    editAdmin: false,
    editInstructor: false,
    departments: [],
    valid: false,
    instructor_deps: [],
    companyEducationResponsible_deps: [],
    distanceEducationAdministrator_deps: [],
    departmentAdministrator_deps: [],
    isDistanceEducationAdministrator_switch: false,
    isInstructor_switch: false,
    isDepartmentAdministrator_switch: false,
    isCompanyEducationResponsible_switch: false,
    isAdministrator_switch: false
  }),
  watch: {
    /**
     * @vuese
     * Used to watch route and recall  the method init if the route changes
     */
    $route() {
      this.init();
    },
    isInstructor_switch(val) {
      if (val == false) {
        this.removeRoles("instructor");
      }
    },
    isCompanyEducationResponsible_switch(val) {
      if (val == false) {
        this.removeRoles("yua");
      }
    },
    isDistanceEducationAdministrator_switch(val) {
      if (val == false) {
        this.removeRoles("dua");
      }
    },
    isDepartmentAdministrator_switch(val) {
      if (val == false) {
        this.removeRoles("departmentAdmin");
      }
    },
  },
  created() {
    this.init();
  },
  /**
   * @vuese
   * Used to display full name
   */
  filters: {
    displayName: function (value) {
      if (value && value.firstName && value.lastName) return value.firstName + " " + value.lastName;
      
      else if(value && value.email)
            return value.email
      return "-"
    },
  },
  computed: {
    ...mapGetters("currentuser", [
      "currentUser",
      "isInstructor",
      "isAdministrator",
      "isCompanyEducationResponsible",
      "isDistanceEducationAdministrator",
      "isDepartmentAdministrator",
      "isImitatingUser",
    ]),
    // isInstructor_switch() {
    //   if (this.hasDepartments(this.$route.params.id) == true) {
    //     if (this.instructor_deps.length > 0) return true
    //   } else {
    //     return this.employee.isInstructor
    //   }
    //   return false
    // },
    // isDepartmentAdministrator_switch() {
    //   if (this.hasDepartments(this.$route.params.id) == true) {
    //     if (this.departmentAdministrator_deps.length > 0) return true
    //   }
    //   return false
    // },
    // isDistanceEducationAdministrator_switch() {
    //   if (this.hasDepartments(this.$route.params.id) == true) {
    //     if (this.distanceEducationAdministrator_deps.length > 0) return true
    //   } else {
    //     return Boolean(this.employee.isDistanceEducationAdministrator)
    //   }
    // },
    // isCompanyEducationResponsible_switch() {
    //   if (this.hasDepartments(this.$route.params.id) == true) {
    //     if (this.companyEducationResponsible_deps.length > 0) return true
    //   } else {
    //     return Boolean(this.employee.isCompanyEducationResponsible)
    //   }
    // }
  },
  methods: {
    init() {

      this.getEmployeeById();
      this.checkEditRoles();
      //this.listDepartments()
    },
    removeRoles(roles) {
      let emp = this.currentUser.employments.find(
        (x) => x.companyId == this.$route.params.id
      );
      emp.departmentEmployments.forEach((dp) => {
        //dp.departmentId
        if (roles == "yua") {
          let found = this.companyEducationResponsible_deps.find(
            (d) => d == dp.departmentId
          );
          if (found && found > 0) {
            this.companyEducationResponsible_deps.splice(
              this.companyEducationResponsible_deps.indexOf(found),
              1
            );
          }
        } else if (roles == "instructor") {
          let found = this.instructor_deps.find((d) => d == dp.departmentId);
          //console.log(this.instructor_deps, "found", found);
          if (found && found > 0) {
            this.instructor_deps.splice(this.instructor_deps.indexOf(found), 1);
          }
          //console.log(this.instructor_deps, "after", found);
        } else if (roles == "departmentAdmin") {
          let found = this.departmentAdministrator_deps.find((d) => d == dp.departmentId);
          if (found && found > 0) {
            this.departmentAdministrator_deps.splice(
              this.departmentAdministrator_deps.indexOf(found),
              1
            );
          }
        } else if (roles == "dua") {
          let found = this.distanceEducationAdministrator_deps.find(
            (d) => d == dp.departmentId
          );
          if (found && found > 0) {
            this.distanceEducationAdministrator_deps.splice(
              this.distanceEducationAdministrator_deps.indexOf(found),
              1
            );
          }
        }
      });
    },
    removeAdmin(item) {
      this.departmentAdministrator_deps.splice(
        this.departmentAdministrator_deps.indexOf(item.value),
        1
      );
    },
    removeDistance(item) {
      this.distanceEducationAdministrator_deps.splice(
        this.distanceEducationAdministrator_deps.indexOf(item.value),
        1
      );
    },
    removeYUA(item) {
      this.companyEducationResponsible_deps.splice(
        this.companyEducationResponsible_deps.indexOf(item.value),
        1
      );
    },
    removeInstructor(item) {
      this.instructor_deps.splice(this.instructor_deps.indexOf(item.value), 1);
    },

    listDepartments() {
      if (!(this.$route && this.$route.params && this.$route.params.id)) return;

      API.listDepartments(this.$route.params.id)
        .then((response) => {
          let emp = this.currentUser.employments.find(
            (x) => x.companyId == this.$route.params.id
          );
          let isDis = false;
          response.data.forEach((d) => {
            isDis = true;
            if (this.isAdministrator) {
              isDis = false;
            } else if (this.hasDepartmentId(emp, d.id) == true) {
              isDis = false;
            }
            else if(this.hasDepartmentIdForRole(emp, d.id, "isDepartmentEducationResponsible") || this.hasDepartmentIdForRole(emp, d.id, 'isDepartmentDistanceEducationAdministrator')) {
              isDis = false
            }

            this.departments.push({ text: d.name, value: d.id, disabled: isDis });
          });
          // this.departments = response.data.map(o => {
          //   return {
          //     text: o.name,
          //     value: o.id
          //   }
          // })
        })
        .catch((error) => {
          console.log("There was an error:", error);
        });
    },
    /**
     * @vuese
     * Used to fetch Employee
     * @arg the argument is an integer representing Employee id
     */
    getEmployeeById() {
      API.getEmployee(this.$route.params.employee_id)
        .then((res) => {
          this.employee = res.data;
          //console.log("emp::", this.employee)
          this.listDepartments();
          this.instructor_deps = [];
          this.departmentAdministrator_deps = [];
          this.companyEducationResponsible_deps = [];
          this.distanceEducationAdministrator_deps = [];
          this.isAdministrator_switch = this.employee.isAdministrator
          if (this.hasDepartments(this.$route.params.id) == true) {
            this.employee.departmentEmployments.forEach((o) => {
              if (o.isDepartmentInstructor == true) {
                this.instructor_deps.push(o.departmentId);
                this.isInstructor_switch = true;
                //this.isInstructor_switch = true
              }
              if (o.isDepartmentEducationResponsible) {
                this.companyEducationResponsible_deps.push(o.departmentId);
                this.isCompanyEducationResponsible_switch = true;
                //this.isCompanyEducationResponsible_switch = true
              }
              if (o.isDepartmentDistanceEducationAdministrator) {
                this.distanceEducationAdministrator_deps.push(o.departmentId);
                this.isDistanceEducationAdministrator_switch = true;
              }
              if (o.isDepartmentAdministrator) {
                this.departmentAdministrator_deps.push(o.departmentId);
                this.isDepartmentAdministrator_switch = true;
              }
            });
          }
          else {
            this.isInstructor_switch=this.employee.isInstructor
            this.isCompanyEducationResponsible_switch=this.employee.isCompanyEducationResponsible            
            this.isDistanceEducationAdministrator_switch=this.employee.isDistanceEducationAdministrator
          }
        })
        .catch((error) => {
          console.log("Error ", error);
        });
    },
    /**
     * @vuese
     * Used to check all edit roles for all the users in the system
     */
    checkEditRoles() {
      if (!this.currentUser) return;
      if (this.isAdministrator) {
        this.editAdmin = true;
        this.editInstructor = true;
      } else if (this.isDistanceEducationAdministrator(this.$route.params.id)) {
        this.editAdmin = false;
        this.editInstructor = true;
      }
    },
    /**
     * @vuese
     * Used to save Employee if form is valid
     * @arg The argument is an integer representing employee id and params are the permission form fields
     */
    saveEmployee() {
      if (!this.$refs.form.validate()) {
        this.$events.fire("showError", this.$t("errors.form-validation"));
        return;
      }
      let updateFields = {};
// console.log(this.instructor_deps, "depss::", this.departments)
// this.instructor_deps=[]

      if (this.hasDepartments(this.$route.params.id)) {
        //if (this.isInstructor_switch == false) this.instructor_deps = [];
        // if (this.isCompanyEducationResponsible_switch == false)
        //   this.companyEducationResponsible_deps = [];
        // if (this.isDistanceEducationAdministrator_switch == false)
        //   this.distanceEducationAdministrator_deps = [];
        // if (this.isDepartmentAdministrator_switch == false)
        //   this.departmentAdministrator_deps = [];
        if (this.currentUser && this.isAdministrator) {
          updateFields = {
            instructorDepartmentIds: this.instructor_deps,
            educationResponsibleDepartmentIds: this.companyEducationResponsible_deps,
            distanceEducationAdministratorDepartmentIds: this.distanceEducationAdministrator_deps,
            administratorDepartmentIds: this.departmentAdministrator_deps,
            isAdministrator: this.isAdministrator_switch
          };
        }
        else {
          updateFields = {
              instructorDepartmentIds: this.instructor_deps
          }
        }
      } else {
        if (this.currentUser && this.isAdministrator) {
          updateFields = {
            isInstructor: this.isInstructor_switch,
            isCompanyEducationResponsible: this.isCompanyEducationResponsible_switch,
            isDistanceEducationAdministrator: this.isDistanceEducationAdministrator_switch,
            isAdministrator: this.isAdministrator_switch
            //isAdministrator: this.employee.isAdministrator,
          };
        } else if (
          this.currentUser &&
          this.isCompanyEducationResponsible(this.$route.params.id) == true
        ) {
          updateFields = {
            //isInstructor: this.isInstructor(this.$route.params.id),
            isInstructor: this.isInstructor_switch,
          };
        }
      }
      API.updateEmployment(this.employee.id, { data: updateFields })
        .then((res) => {
          this.$events.fire("showInfo", this.$t("success.saved"));
          if(this.isAdministrator){
            this.getEmployeeById(this.employee.id);
          }else {
            this.$nextTick(() => {
                  this.$router.push({
                    name: 'CompanyEmployeesPermissions',
                    params: { id: this.$route.params.id },
                  });
                })
          }
        })
        .catch((error) => {
          console.log("Error ", error);
        });
    },
  },
};
</script>

<style lang="scss"></style>
